import React, {useState, useEffect} from "react";
import "../components/Blog.css";
import { useLocation } from "react-router-dom";

const BlogDetails = () => {
  const location = useLocation();

  const [otherblogs, setOtherBlogs] = useState([]);

  // Fetch Blogs
  const fetchBlogs = async () => {
    try {
      const res = await fetch("reactapi/api/codeinputs/get_otherblogs", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ url: location.pathname }),
      });
      const data = await res.json();
      setOtherBlogs(data.html || []);
      console.log(otherblogs.length);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);
  return (
    <>
      {/* BLOG HERO */}
      <section className="blog-hero">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h1>
                How to Change Passwords in cPanel: A Step-by-Step Guide
              </h1>
              <p>
                Published by <strong>Code Inputs</strong> • Complete Guide
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BLOG CONTENT */}
      <section className="blog-wrapper">
        <div className="container">
          <div className="row">

            {/* BLOG MAIN CONTENT */}
            <div className="col-lg-8">
              <div className="blog-card">

                <p>
                  If you’re hosting your website with Namecheap and need to update your cPanel password, rest assured it’s a straightforward process. Whether you’ve misplaced your current password or simply want to enhance your account’s security, this comprehensive guide will provide you with all the details you need, step by step.
                </p>

                <img src="/graphics/images/Cpanel_Change_Password.webp" alt="C Panel Password Change" />

                <h2>C Panel Password Change</h2>
                <p>
                  Your cPanel password acts as the gateway to your website’s backend, granting you control over essential aspects like file management, email accounts, databases, and much more. Regularly updating this password ensures better protection against unauthorized access and potential security breaches. Think of it as periodically upgrading the locks to your digital property—it’s an easy yet critical step toward keeping your website safe.
                </p>

                <h2>Detailed Steps to Change Your cPanel Password on Namecheap</h2>

                <h3>Step 1: Log In to Your Namecheap Account</h3>
                
                <p>Start by accessing your Namecheap account:</p>

               <ol>
                  <li>Open your browser and navigate to Namecheap’s login page.</li>
                  
                  <li>Input your username and password into the respective fields, then click the Sign In button to proceed.</li>
                  
                  <img src="/graphics/images/cpanel_login.webp" alt="C Panel Password Change" />

                  <li>Transfers files securely using SSH encryption.</li>
                  
                  <li>Ensures data integrity and confidentiality.</li>
              </ol>

              <h3>Step 2: Locate Your Hosting Dashboard</h3>

              <ol>
                  <li>After logging in, go to your Dashboard to view an overview of your account.</li>
                  
                  <li>Scroll through the list of services to find the specific domain or hosting plan you want to manage.</li>

                  <li>Click the Manage button next to your selected hosting service to access its settings.</li>

                  <img src="/graphics/images/list_domain.webp" alt="C Panel Password Change" />
              </ol>

              <h3>Step 3: Access cPanel</h3>

               <ol>
                  <li>Within the hosting management interface, look for the Go to cPanel option and click on it.</li>
                  
                  <li>This action will redirect you to your cPanel, where you can manage your website’s backend operations.</li>

              </ol>

               <h3>Step 4: Navigate to the Password and Security Section</h3>

              <ol>
                  <li>Inside the cPanel dashboard, find the Preferences section. If you’re unsure, use the search bar at the top to quickly locate it.</li>
                  
                  <li>Click on Password & Security to begin the password change process.</li>

                  <img src="/graphics/images/password_n_security.webp" alt="C Panel Password Change" />
                  
              </ol>

               <h3>Step 5: Update Your Password</h3>

               <ol>
                  <li>You’ll see fields for your current password and the new password. Start by entering your existing password.</li>
                  
                  <li>Next, create a strong new password. For maximum security, use a mix of uppercase and lowercase letters, numbers, and special characters.</li>

                  <li>Re-enter the new password to confirm it, ensuring both entries match exactly.</li>

                  <li>Click the Change Your Password Now button to save your changes. Once the password is updated, cPanel will automatically log you out.</li>
                  
                  <img src="/graphics/images/changepwds.webp" alt="C Panel Password Change" />
              </ol>

              <h3>Log In with Your New Password</h3>

              <p>Use your newly created password to log back into your cPanel. Take a moment to verify that everything is functioning as expected.</p>

            <h2>What to Do If You’ve Forgotten Your Current Password</h2>

            <p>In case you can’t recall your current cPanel password, don’t panic. Here’s how to reset it via Namecheap:</p>
            
            <ol>
                <li>Go to the Hosting List section of your Dashboard after logging into Namecheap.</li>
                
                <li>Find the hosting plan you wish to manage and click the Manage button.</li>

                <li>Select the Reset Password option. Follow the on-screen prompts, and Namecheap will send a password reset link to your registered email address. Simply follow the instructions in the email to create a new password.</li>
            </ol>

            <h2>Pro Tips for Crafting a Strong cPanel Password</h2>

            <ol>
              <li>Avoid Predictable Choices: Refrain from using common words, dates, or phrases that might be easy to guess.</li>
              <li>Make It Unique: Ensure that your cPanel password is distinct from passwords you use for other accounts.</li>
              <li>Leverage a Password Manager: Tools like LastPass or 1Password can generate robust passwords and store them securely, so you don’t have to remember them all.</li>
            </ol>

            <h2>Final Thoughts</h2>

            <p>Taking the time to change your cPanel password on Namecheap is a small but impactful step toward safeguarding your website. Whether you’re performing a routine security check or recovering access after forgetting your password, these simple steps will guide you through the process seamlessly. Don’t wait—secure your account now and enjoy peace of mind knowing your digital assets are well-protected!</p>
        
          </div>
        </div>

             {/* SIDEBAR */}
            <div className="col-lg-4">
              <div className="blog-sidebar">

                <div className="sidebar-card">
                  <h4 className="sidebar-title">Other Blogs</h4>

                    {otherblogs.length === 0 ? (
                    <p className="text-muted">No blogs found</p>
                  ) : (
                    otherblogs.map((item, index) => (
                      <a
                        href={`/${item.route}`}
                        className="other-blog"
                        key={index}
                      >
                        <img
                          src={`/graphics/images/${item.image}`}
                          alt={item.title}
                        />
                        <div>
                          <h6>{item.title}</h6>
                          <span>
                            {Math.floor(Math.random() * 10) + 1} min read
                          </span>
                        </div>
                      </a>
                    ))
                  )}

                </div>

                <div className="sidebar-card text-center">
                  <h5 className="mb-2">Need Custom Software?</h5>
                  <p className="small text-muted mb-3">
                    Let’s build something amazing together.
                  </p>
                  <a href="/contact" className="btn btn-primary w-100">
                    Contact Us
                  </a>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default BlogDetails;
